import React from "react";

const BlockingInput = ({ name }) => (
  <input name={name} style={{ opacity: 0, width: 0, height: 0, border: 0, padding: 0 }} required value="" />
);
export default BlockingInput;
